module.exports = __webpack_public_path__ + "img/icon4.c7ad5506.svg";